type TimelineItem = {
  primary: string | number;
  secondary: string;
};

type IntervieweeTimelineProps = {
  title?: string;
  items: TimelineItem[];
};

export function IntervieweeTimeline({ title = "Timeline", items }: IntervieweeTimelineProps) {
  return (
    <div className="interviewee-timeline">
      <div className="card-accent" aria-hidden="true" />
      <h3 className="interviewee-timeline__title">{title}</h3>
      <div className="interviewee-timeline__section-content">
        {items.map((item, index) => (
          <article key={`${item.primary}-${item.secondary}-${index}`} className="interviewee-timeline__entry">
            <aside className="interviewee-timeline__marker" aria-hidden="true">
              <div className="interviewee-timeline__dot" />
              <div className="interviewee-timeline__line" />
            </aside>
            <main className="interviewee-timeline__body">
              <h3 className="interviewee-timeline__value">{item.primary}</h3>
              <p className="interviewee-timeline__label">{item.secondary}</p>
            </main>
          </article>
        ))}
      </div>
    </div>
  );
}
